import React, { useState, useEffect, useRef } from 'react';
import { FaUser } from 'react-icons/fa';
import { useStream } from '../contexts/StreamContext';
import './ViewerCount.css';

const ViewerCount = () => {
  const { streamId, streaming } = useStream();
  const [viewerCount, setViewerCount] = useState(0);
  const [displayCount, setDisplayCount] = useState(viewerCount);
  const [animating, setAnimating] = useState(false);

  const viewerCountRef = useRef(viewerCount);
  useEffect(() => {
    viewerCountRef.current = viewerCount;
  }, [viewerCount]);

  useEffect(() => {
    if (!streamId || !streaming) return;

    const fetchViewerCount = async () => {
      try {
        // const res = await fetch(`http://localhost:3002/streams/${streamId}/viewers`);
        const res = await fetch(`https://192.168.1.210:3002/streams/${streamId}/viewers`);
        const data = await res.json();
        if (data.count !== viewerCountRef.current) {
          setAnimating(true);
          setTimeout(() => {
            setViewerCount(data.count);
            viewerCountRef.current = data.count;
            setAnimating(false);
          }, 300);
        }
      } catch (err) {
        console.error('Viewer count error:', err);
      }
    };

    fetchViewerCount(); // fetch once immediately
    const interval = setInterval(fetchViewerCount, 5000);

    return () => clearInterval(interval);
  }, [streamId, streaming]);


  useEffect(() => {
    if (!animating) {
      setDisplayCount(viewerCount);
    }
  }, [viewerCount, animating]);

  return (
    <div className="user-count">
      <FaUser />
      <div className="viewer-count-wrapper">
        <div
          className={`viewer-count-number ${
            animating ? 'viewer-count-exit-active' : 'viewer-count-enter-active'
          }`}
        >
          {displayCount}
        </div>
      </div>
    </div>
  );
};

export default ViewerCount;
